export enum HTMLFormTypeEnum {
  DROPDOWN = 'DROPDOWN',
  INPUT_FIELD = 'INPUT_FIELD',
  CHECKBOX = 'CHECKBOX',
  SUBMIT_BUTTON = 'SUBMIT_BUTTON',
  UNKNOWN = 'UNKNOWN',
  FORM_SECTION_TITLE = 'FORM_SECTION_TITLE',
  INFO_BOX = 'INFO_BOX',
}
